import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { selectors as settingsSelectors } from 'state/settings';
import { actions as orderActions } from 'state/order';
import {
  actions as paymentDataActions,
  selectors as paymentDataSelectors,
} from 'state/paymentData';

import PaymentMethodSelector from 'components/PaymentData/PaymentMethodSelector/component';

const enhance = compose(
  withTranslation('PaymentData'),
  connect(
    (state) => ({
      country: settingsSelectors.getCountrySettings(state),
      paymentMethod: paymentDataSelectors.getPaymentMethod(state),
    }),
    {
      fetchQuote: orderActions.fetchQuote,
      selectPaymentMethod: paymentDataActions.selectPaymentMethod,
      changePaymentTerm: paymentDataActions.changePaymentTerm,
    }
  ),
  lifecycle({
    componentDidMount() {
      const { fetchQuote } = this.props;

      fetchQuote();
    },
  }),
  withHandlers({
    handlePaymentMethodSelector:
      ({ selectPaymentMethod }) =>
      (e, { value }) => {
        e.preventDefault();
        selectPaymentMethod({ value: (value || '').toUpperCase() });
      },
    handleChangePaymentTerm:
      ({ changePaymentTerm }) =>
      (e, { name, value }) => {
        e.preventDefault();
        changePaymentTerm({ field: name, value });
      },
  })
);

export default enhance(PaymentMethodSelector);
